import { Wording } from '@/types';

export const MEDITATION_WORDING_EN: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Meditations',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Guides',
  components_header_text2: 'Blog',
  components_header_members: 'Members',
  hero_text: 'Where Meditation Meets the Stars',
  hero_button_text: 'Start Your Journey Inward',
  components_ressources_section_title: 'RESOURCES',
  components_ressources_subheader_text: 'Tools for Inner Peace, Grounding, and Everyday Balance',
  components_ressources_span_text: 'Open the door to inner peace with our handpicked meditations and guides. Find clarity, reconnect with your breath, and align with your inner rhythm—one mindful moment at a time.',
  components_ressources_card_1_title: 'Reflection',
  components_ressources_card_1_text: 'Short meditations and audio reflections to center your thoughts and realign with your cosmic rhythm.',
  components_ressources_card_2_title: 'Explore the Depths',
  components_ressources_card_2_text: 'Journey beyond the surface with immersive guides that blend meditation, astrology, and self-inquiry for lasting transformation.',
  components_ressources_link: 'See More',
  components_notes_and_google_title_1: 'Soulful Guidance',
  components_notes_and_google_title_2: 'Mindful Rituals',
  components_notes_and_google_title_3: 'Guided Meditations',
  components_review_google_text: 'Google Reviews',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Our meditations',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Discover more',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: 'Cosmic Knowledge for Daily Alignment',
  components_text1_span_text: 'Align with the rhythms of the universe: explore a curated collection of in-depth astrological and meditative guides designed to awaken inner clarity, deepen self-awareness, and support your journey of soulful, celestial growth.',
  components_text1_card_1_title: 'Open to the Quiet',
  components_text1_card_1_text: 'Begin your journey with foundational meditation and astrology guides—ideal for seekers drawn to inner stillness, cosmic patterns, and personal insight.',
  components_text1_card_3_title: 'Mind–Body Link',
  components_text1_card_3_text: 'Uncover the deeper layers of your inner world. These guides move beyond the surface to reveal meaning, emotion, and mindful patterns that shape your experience.',
  components_text1_card_2_title: 'Reflect & Integrate',
  components_text1_card_2_text: 'From emotional blocks to planetary cycles—these guides offer tools for reflection, healing, and transformation through mindful rituals and astrological wisdom.',
  components_text1_link: 'View All Guides',
  components_footer_text: 'Awaken Within: Your Stillness, Your Strength',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registration number',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Terms and Conditions',
  components_footer_privacy: 'Privacy Policy',
  button_load_more: 'Load More',
  page_media_1_content_hero_text: 'Meditations',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Energy Boost',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Guides',
  page_text1_section_title: 'Guides',
  page_text1_subheader_text: 'Our guides',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Please enter your email to continue',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Enter',
  components_login_success_text: 'Login successful!',
  components_card_link_media_content: 'Listen Now',
  components_card_link_text1_content: 'View Guide',
  components_card_link_text2_content: 'Explore',
  france: 'France',
  cyprus: 'Cyprus',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditation',
  page_media_content_menu_all: 'All',
};